<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	
	// Public Properties
	export let total: number = 0;
	export let currentPage: number = 1;

	// Private Properties
	const dispatch = createEventDispatcher();
	const dummyUrl = '#';

	// Including "total" updates the pages when the total property changes
	$: pages = setPages(currentPage, total);

	// Private Methods
	function setPages(current, total) {
		current = Number(current - 1);

		const pages = Array.from(Array(total || 1).keys()).map(i => i + 1);
		const pageLimit = 5;
		const padding = (pageLimit - 1) / 2;
		const startMin = 0;
		const startMax = (total - pageLimit) >= 0 ? (total - pageLimit) : 0;
		const endMin = total >= pageLimit ? (pageLimit - 1) : total - 1 > 0 ? total - 1: 0;
		const endMax = total - 1 > 0 ? total - 1: 0;
		
		let start = 0;
		let end = endMin;
		
		if (current - padding > startMin && current - padding <= startMax) {
			start = current - padding;
		}
		
		if (current - padding > startMax) {
			start = startMax;
		}
		
		if (current + padding > endMin && current + padding <= endMax) {
			end = current + padding;
		}
		
		if (current +padding > endMax) {
			end = endMax;
		}
		
		return pages.slice(start, end + 1);
	}

	function navigate(e) {
		const page = e.target.closest('.page-item').dataset.page;
		const oldPage = currentPage;

		if (page === '-1' && currentPage - 1 > 0) {
			currentPage--;
		}
		
		if (page === '+1' && currentPage + 1 <= total) {
			currentPage++;
		}

		if (page !== '-1' && page !== '+1') {
			currentPage = Number(page);
			// @ts-ignore
			document.activeElement.blur();
		}
		
		if (Number(currentPage) !== Number(oldPage)) {
			dispatch('navigated', Number(currentPage));
			return;
		}
	}
</script>

<nav class="pagination-overflow" aria-label="Page navigation example">
	<ul class="pagination justify-content-center">
		<li
				class="page-item"
				class:disabled="{currentPage <= 1}"
				data-page="1"
				on:click|preventDefault|stopPropagation="{navigate}"
				>
			<a class="page-link" href="{dummyUrl}">First</a>
		</li>

		<li
				class="page-item"
				class:disabled="{currentPage <= 1}"
				data-page="-1"
				on:click|preventDefault|stopPropagation="{navigate}"
				>
			<a class="page-link" href="{dummyUrl}">Previous</a>
		</li>

		{#each pages as page}
		<li
				class="page-item"
				class:active="{page == (currentPage || 1)}"
				data-page="{page}"
				on:click|preventDefault|stopPropagation="{navigate}"
				>
			<a class="page-link" href="{dummyUrl}">{page}</a>
		</li>
		{/each}

		<li
				class="page-item"
				class:disabled="{currentPage >= total}"
				data-page="+1"
				on:click|preventDefault|stopPropagation="{navigate}"
				>
			<a class="page-link" href="{dummyUrl}">Next</a>
		</li>

		<li
				class="page-item"
				class:disabled="{currentPage >= total}"
				data-page="{total}"
				on:click|preventDefault|stopPropagation="{navigate}"
				>
			<a class="page-link" href="{dummyUrl}">Last</a>
		</li>
	</ul>
</nav>

<style>
	.pagination-overflow {
		overflow: auto;
	}

	.pagination {
		display: flex;
		margin: 0;
	}
</style>